import { InjectionToken } from '@angular/core';

export const MODAL_OPTIONS = new InjectionToken<string>('MODAL_OPTIONS');
